import { render, staticRenderFns } from "./CmgOrderStatusBar.vue?vue&type=template&id=449cea5a&scoped=true&lang=pug"
import script from "./cmg-order-status-bar.ts?vue&type=script&lang=ts&external"
export * from "./cmg-order-status-bar.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgOrderStatusBar.vue?vue&type=style&index=0&id=449cea5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449cea5a",
  null
  
)

export default component.exports